import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Cover from '../components/cover/cover'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faShieldVirus } from "@fortawesome/free-solid-svg-icons"

import cover from "../images/covid-cover-alt.jpg"
import ContactForm from '../components/form/form'
import { StaticImage } from "gatsby-plugin-image"

const CovidPage = () => (
  <Layout>
    <SEO title="We Clothe Them - Covid Precautions" />
    <Cover
      image={cover}
      title={`Covid - Safety & Precautions`}
      button={``}
    />
    <section>
        <div className={`content-sm`}>
            <h6 className={`letter-spaced-heading`}>Safety & Precuations</h6>
            <h2><span className={`secondary`}><FontAwesomeIcon icon={faShieldVirus} /></span> Covid Measures</h2>
            <p>We at We Clothe Them are taking all the necessary precautions during the COVID-19 Pandemic to continue our endeavour     with ease and serve our purpose.</p>
            <p><b>Step 1:</b>  We proactively request everyone to wash their clothes and then donate the clothes to us</p>
            <p><b>Step 2:</b> We bring the clothes to our pew sanitised premises and segregate the clothes for demographics wearing     all safety equipment like masks and gloves</p>
            <p><b>Step 3:</b> We pack the clothes in plastic bags to avoid any further exposure</p>
            <p className={`margin-bottom`}><b>Step 4:</b> We leave the clothes for at least 7 days before distributing them to ensure clothes are fully     disinfected</p>
            <hr />
            <div className={`gallery`}>
                <div className={`image`}>
                    <div className={`static-image-wrapper`}>
                    <StaticImage src={'../images/covid-cover.jpg'} width={600} quality={95} formats={["AUTO", "WEBP", "AVIF"]} />
                    </div>
                </div>
                <div className={`image`}>
                    <div className={`static-image-wrapper`}>
                    <StaticImage src={'../images/covid-precautions.jpg'} width={600} quality={95} formats={["AUTO", "WEBP", "AVIF"]} />
                    </div>
                </div>
                <div className={`image`}>
                    <div className={`static-image-wrapper`}>
                    <StaticImage src={'../images/covid-1.jpg'} width={600} quality={95} formats={["AUTO", "WEBP", "AVIF"]} />
                    </div>
                </div>
                <div className={`image`}>
                    <div className={`static-image-wrapper`}>
                    <StaticImage src={'../images/covid-2.jpg'} width={600} quality={95} formats={["AUTO", "WEBP", "AVIF"]} />
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading center`}>Contact</h6>
        <h2 className={`center margin-bottom`}>Write to Us</h2>
        <ContactForm />
      </div>
    </section> */}
  </Layout>
)

export default CovidPage